type LoadFeature = {
  feature: string;
  openOnLoad: boolean;
  params: {
    language: string;
    sysparm_vaMarket: string;
    sysparm_consumer_cas_uuid?: string;
  };
};

export type LiveChatObject = {
  init: ({
    moduleID,
    loadFeature,
    tokenCallBack,
  }: {
    moduleID: string;
    loadFeature: LoadFeature;
    tokenCallBack?: () => void;
    lang: string;
  }) => void;
  loadEMFeature(): LoadFeature;
  onLogin?: () => void;
  onLogout?: () => void;
};

declare global {
  interface Window {
    SN_CSM_EC?: LiveChatObject;
  }
}

export const onLogin = (): void => {
  window.SN_CSM_EC?.onLogin?.();
};

export const onLogout = (): void => {
  window.SN_CSM_EC?.onLogout?.();
};
